import { initializeApp } from 'firebase/app';
import { Android } from './utils/android';
import { getMessaging, getToken } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBhFdDJK---Wa0a5ZrbpEIECpe3y_ZnHSk",
    authDomain: "paging-project-4010e.firebaseapp.com",
    projectId: "paging-project-4010e",
    storageBucket: "paging-project-4010e.appspot.com",
    messagingSenderId: "661584381077",
    appId: "1:661584381077:web:66437e32a785f83cba879c",
    measurementId: "G-Q8QJJJC18D"
};

const { app, messaging } = (() => {
    if (Android.isEmbedded())
        return { app: undefined, messaging: undefined, };

    // Initialize Firebase if not mbedded
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    return { app, messaging };
})();

export const getTokenAsync = async () => {
    if (Android.isEmbedded() || !messaging) {
        return Android.getFirebaseToken();
    }

    try {
        return await getToken(messaging, { vapidKey: 'BOjfMuUyhwLj2ZcKN0kaIVLKbC3M-amYPQRBLe0UDa_QMQgj_-mEE_UNu4yiL_ga-qEPL6WXLxqlr6MuFHZOzBg' });
    } catch (ex) {
        console.error('Error getting firebase token', ex);
        return undefined;
    }
}

export const requestPermission = () => {
    if (Android.isEmbedded()) return;

    console.log('Requesting notification permission...');
    if ('Notification' in window) {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission is granted.');
            } else {
                console.error('Notification permission are not granted. The web app will be unable alert properly without them.')
            }
        });
    }
}